import filter from 'lodash/filter';
import uniqBy from 'lodash/uniqBy';
import { getMapData } from '../../utils/api';
import { getParamUrl, isMobile } from '../../utils/utils';
import { loadColor } from './tradeAdvisory';

const $ = window.jQuery;

export const geo2PX = (obj, selector) => {
  const W = $(selector).width();
  const H = $(selector).height();
  return {
    x: ((obj.longitude + 180) * W / 360),
    y: H - ((obj.latitude + 85) * H / 170)
  }
}

export const total = (data) => {
  let t = 0;
  data.forEach(element => {
    t += element.total;
  });
  return t;
}

export const fontSize = (element) => {
  if (element.radius >= 5 && element.radius < 20) {
    return 10;
  } else if (element.radius >= 20 && element.radius < 25) {
    return 13;
  } else if (element.radius >= 25 && element.radius < 35) {
    return 14;
  } else {
    return 10;
  }
}

export const getText = (element) => {
  const d = element.radius * 2;
  const w = Math.sqrt(Math.pow(element.radius, 2) * 2);
  if (element.radius >= 0 && element.radius < 10) {
    return { w: w, d: d, text: "" };
  } else if (element.radius >= 10 && element.radius < 35) {
    return { w: w, d: d, text: "<div class='text-inner-circle' style='width: " + w + "px;height: " + w + "px'>" + element.iso2 + "<div>" }
  } else {
    return { w: w, d: d, text: "<div class='text-inner-circle' style='width: " + w + "px;height: " + w + "px'>" + element.name + "<br/><b>" + element.percentText + "%</b><div>" }
  }
}

export const resetAllGeo = () => {
  const svg = window.d3.selectAll('svg.geomapsvg');
  svg.remove();
}

export const setupMap = (data = [], selector = "#geomap") => {
  resetAllGeo();
  data = uniqBy([...filter(data, { code: getParamUrl("destination") }), ...data.sort(function (a, b) { return b.total - a.total }).slice(0, 40)], "code");

  const width = $(selector).width();
  const height = $(selector).height();

  data.forEach((element) => {
    const pixel = geo2PX({ latitude: element.latitude, longitude: element.longitude }, selector);
    const totalS = Math.pow(width / (window.outerWidth > 767 ? 4 : 3), 2) * Math.PI;
    const r = Math.sqrt((element.total / total(data)) * totalS) / Math.PI;
    const s = Math.PI * Math.pow(r, 2);
    element.radius = r;
    element.realRadius = Math.sqrt((element.percent * s) / Math.PI);
    element.x = pixel.x
    element.y = pixel.y + 100
    return element;
  }, data)

  const svg = window.d3.select(selector).append("svg")
    .attr("class", 'geomapsvg')
    .attr("width", width)
    .attr("height", height);

  const nodes = data.map(function (element) {
    const d = { ...element };
    return d;
  });

  window.d3.forceSimulation(nodes)
    .velocityDecay(0.5)
    .force('x', window.d3.forceX().strength(0.002))
    .force('y', window.d3.forceY().strength(0.002))
    .force("collide", window.d3.forceCollide().radius(function (d) {
      return d.radius + 2;
    }).iterations(2))
    .on("tick", function () {
      // $('.map-tooltip-parent').hide();
      svg.selectAll("g").remove();
      svg.selectAll("foreignObject").remove();
      svg.selectAll("circle").remove();
      nodes.forEach(element => {
        const text = getText(element);
        const font = fontSize(element);
        const g = svg.append('g').attr("id", "g-" + element.iso2)
        g.append("circle")
          .attr("id", element.iso2)
          .attr("class", "circle-hover")
          .attr("r", element.radius)
          .attr("cx", element.x)
          .attr("cy", element.y)
          .style("fill", element.color)
          .style("opacity", .5)
        g.append("circle")
          .attr("class", "circle-child")
          .attr("r", element.realRadius)
          .attr("cx", element.x)
          .attr("cy", element.y)
          .style("fill", element.color)
        g.append("foreignObject")
          .attr('class', 'svg-text')
          .attr("width", text.w)
          .attr("height", text.w)
          .attr("x", element.x - (text.w / 2))
          .attr("y", element.y - (text.w / 2))
          .attr("font-size", font)
          .html(text.text)
          .style("fill", '#383838')
          .style("width", '#383838')
      });
    })
}

export const initMap = () => {
  $('body').on('mouseenter', 'circle.circle-hover', function () {
    const circle = $(this);
    const id = circle.attr('id');
    const r = parseFloat(circle.attr('r'));
    const top = parseFloat(circle.attr('cy'));
    let left = parseFloat(circle.attr('cx'));
    const element = window.globalData.filter(obj => obj.iso2 === id)[0];
    left = (left - $('.map-tooltip-parent').width() - 17 - r);
    $('.map-tooltip .title').html(element.name)
    $('.map-tooltip .box .value.untapText').html(element.untapText)
    $('.map-tooltip .box .value.actualText').html(element.actualText)
    $('.map-tooltip .box .value.totalText').html(element.totalText)
    $('.map-tooltip .box .value.untapText').attr("title", element.untapTextRaw)
    $('.map-tooltip .box .value.actualText').attr("title", element.actualTextRaw)
    $('.map-tooltip .box .value.totalText').attr("title", element.totalTextRaw)
    $('.map-tooltip-parent')
      .css('top', (top - (left < 0 ? (window.outerWidth > 767 ? -30 : -10) : 37)) + "px")
      .css('left', (left < 0 ? 0 : left) + "px")
      .show();
    if (left < 0) {
      $(".map-tooltip-parent .map-tooltip").addClass("hide-arrow");
    } else {
      $(".map-tooltip-parent .map-tooltip").removeClass("hide-arrow");
    }
  })
  if (!isMobile()) {
    $('body').on('mouseleave', '#geomap', function (e) {
      $('.map-tooltip-parent').hide();
    })
    $('#geomap').on('click', function (e) {
      if (!$(e.target).parents('.map-tooltip-parent').length && !$(e.target).parents('circle.circle-hover').length) {
        $('.map-tooltip-parent').hide();
      }
    })
  } else {
    // $('body').on('mouseleave', 'circle.circle-hover', function (e) {
    //   $('.map-tooltip-parent').hide();
    // })
  }

  $('.description-modal .detail').on('click', function (e) {
    e.stopPropagation();
  });
  $('.collapsing-link').on('click', function (e) {
    e.stopPropagation();
    var element = $(`#${e.target.slot}`);
    if (["ease_of_trade", "demand", "export_potential_indicator", "supply_ep"].includes(e.target.slot)) {
      $("#glossary_1").collapse("show");
    }
    if (element && element[0]) {
      $('#modal_notice').animate({
        scrollTop: element[0].offsetTop
      });
    }
  });
}

export const getMap = (params, exportCountryObj, destinationCountryObj, apiTime) => {
  getMapData(params, function (data) {
    $(".section-market-static").removeClass('loading');
    if (data.length) {
      $(".section-market-static").css('display', 'block');
      $(".section-market-static .opportunity").css('display', 'block');
      window.globalData = data;
      setupMap(data);
      loadColor();
    }
  }, function (error) {
    $(".section-market-static").removeClass('loading');
    console.error(error);
  }, apiTime);
}